import { render, staticRenderFns } from "./ForRouter.vue?vue&type=template&id=2bf99a92&scoped=true&"
import script from "./ForRouter.vue?vue&type=script&lang=js&"
export * from "./ForRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf99a92",
  null
  
)

export default component.exports